import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import ValidationError from "../../ZodError";
export const SuccessResponse = z.object({
    totalAccountsAdded: z.number(),
    updatedRows: z.number(),
});
export const FailureResponse = z.object({ message: z.string() });
const urlV2 = () => {
    return environment() === "PROD"
        ? "https://middleware.prod.farther.com/account/v2/admin/farther-accounts/bulk"
        : "https://middleware.uat.farther.com/account/v2/admin/farther-accounts/bulk";
};
export default async function uploadBulkAccounts(bulkAccountsDocument, onboardingOptions, config) {
    const formData = new FormData();
    formData.append("fisier", bulkAccountsDocument);
    Object.entries(onboardingOptions).forEach(([option, bool]) => {
        formData.append(option, `${bool}`);
    });
    const { data, status } = await axios.postForm(urlV2(), formData, {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            Advisor: config.advisorId,
        },
        validateStatus: function (status) {
            return status === 200 || status === 400;
        },
    });
    switch (status) {
        case 200: {
            const decoded = SuccessResponse.safeParse(data);
            if (decoded.success) {
                return { status: "valid", data: decoded.data };
            }
            else {
                const errorMessage = `${uploadBulkAccounts.name} Could not parse`;
                errorLog(uploadBulkAccounts.name, decoded.error.message);
                throw new ValidationError(errorMessage, decoded.error.issues);
            }
        }
        case 400: {
            const decoded = FailureResponse.safeParse(data);
            if (decoded.success) {
                return { status: "failed", data: decoded.data };
            }
            else {
                const errorMessage = `${uploadBulkAccounts.name} Could not parse`;
                errorLog(uploadBulkAccounts.name, decoded.error.message);
                throw new ValidationError(errorMessage, decoded.error.issues);
            }
        }
        default:
            throw new Error(`Unexpected HTTP status ${status} received`);
    }
}
//# sourceMappingURL=uploadBulkAccountsV2.js.map